import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

export const Remainder = withNamespaces()(
  observer(({ itemCount, maxLen, itemName, show = true, fieldStore }) => {
    if (itemCount === 0) {
      if (show) {
        let msg = <Trans>Select from existing {{ itemName }}s</Trans>;
        if (
          fieldStore &&
          fieldStore.conf.autocomplete &&
          fieldStore.conf.autocomplete.allowNew
        ) {
          msg = (
            <Trans>
              Select from existing {{ itemName }}s, or create new ones by
              hitting Enter or Tab
            </Trans>
          );
        }
        if (!fieldStore.conf.autoComplete) {
          return <RemainderSpan>{fieldStore.conf.placeholder}</RemainderSpan>;
        }
        return <RemainderSpan>{msg}</RemainderSpan>;
      }
    } else if (!maxLen) {
      return null;
    } else if (maxLen - itemCount === 1) {
      // use 'pluralise'
      return (
        <RemainderSpan>
          (<Trans>Add 1 more {{ itemName }}</Trans>)
        </RemainderSpan>
      );
    } else if (maxLen - itemCount !== 0) {
      const remainingItems = maxLen - itemCount;
      return (
        <RemainderSpan>
          (
          <Trans>
            Add up to {{ remainingItems }} more {{ itemName }}s
          </Trans>
          )
        </RemainderSpan>
      );
    }
    return null;
  }),
);

const RemainderSpan = styled.span`
  color: rgba(0, 0, 0, 0.4);
  display: inline-block;
`;
